import { EStorageType } from 'reactApp/modules/storage/storage.types';

export const storagesNeededHomeStore = [
    EStorageType.home,
    EStorageType.feed,
    EStorageType.favorites,
    EStorageType.sharedLinks,
    EStorageType.sharedIncoming,
    EStorageType.sharedAutodelete,
];

export const AB_TEST_TRIAL = [
    {
        id: 'trialOffer',
        icon: 'https://r.mradx.net/img/11/6518A6.svg',
        title: '128 ГБ на месяц за 1 рубль',
        text: 'Свободное место для десятков тысяч фото и документов',
        button: 'Попробовать за 1 рубль',
        tariffId: 'W128G_discount_1m_AB_test_2',
        theme: 'banner_light',
    },
    {
        id: 'trialOffer',
        icon: 'https://r.mradx.net/img/11/6518A6.svg',
        title: '256 ГБ на месяц за 1 рубль',
        text: 'Свободное место для десятков тысяч фото и документов',
        button: 'Попробовать за 1 рубль',
        tariffId: 'W256G_discount_1m_AB_test_2',
        theme: 'banner_light',
    },
];
